import React, { useEffect, useMemo, useState } from 'react';
import { MapPin, Phone, MessageCircle } from 'lucide-react';
import '../styles/wedding.css';

export default function WeddingInvite() {
  // ====== BASIC EDITABLE DATA ======
  const COUPLE = { 
    bride: 'Manasvi', 
    groom: 'Nilay',
    groomFullName: 'Nilay',
    groomGrandFather: 'Late Shri Hunipal Singh',
    groomGrandMother: 'Late Smt. Sukhbiri Devi',
    groomFather: 'Dr. Jagdish',
    groomMother: 'Smt. Pushpa Devi',
    brideGrandFather: 'Late Shri Raghunath Prasad Ladia',
    brideGrandMother: 'Late Smt. Bimla Devi',
    brideFather: 'Shri Ashok Kumar Ladia',
    brideMother: 'Smt. Mikki Ladia',
  };
  
  const HASHTAG = '#WeMaNifestedIt';
  
  const WEDDING_DAY_ISO = '2026-02-08T19:00:00+05:30'; // Main Wedding Day - 8th Feb 2026, 7:00 PM IST

  const VENUES = {
    main: {
      name: 'MH1 RESORT',
      address: 'GT Karnal Road, Alipur, Delhi',
      mapsUrl: 'https://www.google.com/maps?q=MH1+RESORT+GT+Karnal+Road+Alipur+Delhi',
    },
    reception: {
      name: 'WEDLOCK GREENS Hotels and Resorts',
      address: 'Gobindpur, Dhanbad, Jharkhand',
      mapsUrl: 'https://www.google.com/maps?q=WEDLOCK+GREENS+Hotels+Resorts+Gobindpur+Dhanbad+Jharkhand',
    }
  };

  const EVENTS = [
    {
      key: 'mehandi',
      title: 'Mehendi',
      subtitle: 'Henna Hues',
      date: 'Saturday, 7th February 2026',
      time: '11:00 AM onwards',
      venue: VENUES.main.name,
      venueAddress: VENUES.main.address,
      dress: 'Green/Pastel (Semi-formal)',
      img: 'https://images.unsplash.com/photo-1622396481337-c1c51e1ae3dd?q=80&w=1600&auto=format&fit=crop',
      videoUrl: 'https://www.youtube.com/embed/VC1PyB_b_fg?autoplay=1&mute=1&loop=1&playlist=VC1PyB_b_fg&controls=0',
    },
    {
      key: 'ring',
      title: 'Ring Ceremony',
      subtitle: 'Rhythm and Rasmein',
      date: 'Saturday, 7th February 2026',
      time: '7:00 PM onwards',
      venue: VENUES.main.name,
      venueAddress: VENUES.main.address,
      dress: 'Ethnic/Festive (Sparkle)',
      img: 'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7bf?q=80&w=1600&auto=format&fit=crop',
      videoUrl: 'https://www.youtube.com/embed/_PU0UzA1YPE?autoplay=1&mute=1&loop=1&playlist=_PU0UzA1YPE&controls=0',
    },
    {
      key: 'haldi',
      title: 'Haldi',
      subtitle: 'Turmeric Tales',
      date: 'Sunday, 8th February 2026',
      time: '11:00 AM onwards',
      venue: VENUES.main.name,
      venueAddress: VENUES.main.address,
      dress: 'Yellow/Floral (Casual)',
      img: 'https://images.unsplash.com/photo-1606313564200-75a0b06eeaf2?q=80&w=1600&auto=format&fit=crop',
      videoUrl: 'https://www.youtube.com/embed/IGkTtQuHgQU?autoplay=1&mute=1&loop=1&playlist=IGkTtQuHgQU&controls=0',
    },
    {
      key: 'wedding',
      title: 'Baraat & Wedding',
      subtitle: 'How I Met My Bride',
      date: 'Sunday, 8th February 2026',
      time: '7:00 PM onwards',
      venue: VENUES.main.name,
      venueAddress: VENUES.main.address,
      dress: 'Traditional Indian',
      img: 'https://images.unsplash.com/photo-1591604129930-9a5d0d9f7bf3?q=80&w=1600&auto=format&fit=crop',
      videoUrl: 'https://www.youtube.com/embed/HKDVLPF1hTI?autoplay=1&mute=1&loop=1&playlist=HKDVLPF1hTI&controls=0',
    },
    {
      key: 'reception',
      title: 'Reception',
      subtitle: 'Happily Ever After',
      date: 'Sunday, 22nd February 2026',
      time: '7:00 PM onwards',
      venue: VENUES.reception.name,
      venueAddress: VENUES.reception.address,
      dress: 'Black Tie/Indian Formals',
      img: 'https://images.unsplash.com/photo-1541534401786-2077eed87a72?q=80&w=1600&auto=format&fit=crop',
      videoUrl: 'https://www.youtube.com/embed/3akGQt3_Cxc?autoplay=1&mute=1&loop=1&playlist=3akGQt3_Cxc&controls=0',
    },
  ];

  const GALLERY = [
    'https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/ztsachnb_122.jpg',
    'https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/gzuvigy6_10.jpg',
    'https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/rgg54czz_54.jpg',
    'https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/fw9pzx7r_134%20%281%29.jpg',
    'https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/wja6gqx9_114.jpg',
  ];

  const VIDEOS = [
    {
      title: 'Wedding Invitation',
      videoSrc: 'https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/kr9s0yt7_Invitation.mp4',
      placeholder: false,
    },
  ];

  const RSVP = {
    whatsapp: 'https://wa.me/918292584106?text=Namaste%2C%0A%0AThank%20you%20for%20inviting%20me%20to%20celebrate%20Nilay%20%26%20Manasvi%27s%20wedding%21%0A%0AI%20would%20like%20to%20RSVP%3A%20____%0A%28Please%20reply%3A%20Yes%2C%20delighted%20to%20attend%20%2F%20No%2C%20regretfully%20cannot%20attend%20%2F%20Will%20confirm%20in%20sometime%29%0A%0ABest%20wishes%20to%20the%20couple%21',
    formLink: 'https://forms.gle/xhTanL739PCr21QW6',
    phone: '+91 8292584106',
    phone2: '+91 8084371124',
    contactPerson: 'Dr. Jagdish and Family',
  };

  // ====== COUNTDOWN LOGIC ======
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const target = useMemo(() => new Date(WEDDING_DAY_ISO).getTime(), []);
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);

  // Scroll reveal animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="wedding-invite">
      {/* Sticky Action Bar */}
      <div className="sticky-bar">
        <a href="#rsvp" className="btn-rsvp">
          <MessageCircle size={18} />
          Confirm Your Presence
        </a>
        <a href={VENUES.main.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn-directions">
          <MapPin size={18} />
          Directions
        </a>
      </div>

      {/* HERO VIDEO - Full Cover Video without text */}
      <section className="hero-image-section">
        <iframe
          src="https://www.youtube.com/embed/13EpQG5JrJc?autoplay=1&mute=1&loop=1&playlist=13EpQG5JrJc&controls=0&playsinline=1&modestbranding=1&rel=0"
          title="Nilay & Manasvi Wedding Video"
          className="hero-cover-video"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </section>

      {/* HERO CONTENT - All text content in separate section */}
      <section className="hero-content-section">
        <div className="container">
          <div className="hero-text-content">
            <div className="wedding-logo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/vmynj6dt_logo_Wed.JPG" 
              alt="Wedding Logo" 
              className="wedding-logo"
            />
          </div>
            <h1 className="couple-names">
              {COUPLE.groom}
              <span className="ampersand">&</span>
              {COUPLE.bride}
            </h1>
            <p className="hero-subtitle">With our families, we invite you to our wedding celebrations</p>
            <div className="countdown">
              <TimeBox label="Days" value={d} />
              <TimeBox label="Hours" value={h} />
              <TimeBox label="Minutes" value={m} />
              <TimeBox label="Seconds" value={s} />
            </div>
            <div className="hero-actions">
              <a href="#events" className="btn-primary">View Events</a>
              <a href="#rsvp" className="btn-secondary">Confirm Your Presence</a>
            </div>
            <div className="hero-hashtag">{HASHTAG}</div>
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* WEDDING CEREMONY SECTION */}
      <section id="ceremony" className="ceremony-section fade-in">
        <div className="container">
          <h2 className="section-title">The Wedding Day</h2>
          <div className="divider-ornament"></div>
          <p className="ceremony-subtitle">
            The day when we will tie the knot and begin our new life as a happily married couple
          </p>
          <div className="wedding-date">Sunday, 8th February, 2026</div>
        </div>
      </section>

      {/* ABOUT COUPLE */}
      <section id="about" className="about-section fade-in">
        <div className="container">
          <h2 className="section-title">Know Us</h2>
          <div className="divider-ornament"></div>
          <div className="couple-grid">
            <PersonCard
              name={COUPLE.groom}
              subtitle={`Grand S/O ${COUPLE.groomGrandFather} and ${COUPLE.groomGrandMother}`}
              location={`S/O ${COUPLE.groomFather} and ${COUPLE.groomMother}`}
              img="https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/sry2f7gd_20250315_101559.jpg"
            />
            <PersonCard
              name={COUPLE.bride}
              subtitle={`Grand D/O ${COUPLE.brideGrandFather} and ${COUPLE.brideGrandMother}`}
              location={`D/O ${COUPLE.brideFather} and ${COUPLE.brideMother}`}
              img="https://customer-assets.emergentagent.com/job_taj-mumbai-wedding/artifacts/v1m5aqkn_Screenshot_20250103_223549_Photos.jpg"
            />
          </div>
          <div className="family-message">
            <h3>From Our Families</h3>
            <p>
              With heartfelt joy, our families invite you to shower the couple with your blessings and love as they
              begin their forever journey together.
            </p>
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* EVENTS */}
      <section id="events" className="events-section fade-in">
        <div className="container">
          <h2 className="section-title">Wedding Events</h2>
          <div className="divider-ornament"></div>
          <div className="events-grid">
            {EVENTS.map((e) => (
              <EventCard key={e.key} ev={e} />
            ))}
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* GALLERY */}
      <section id="gallery" className="gallery-section fade-in">
        <div className="container">
          <h2 className="section-title">Our Beautiful Moments</h2>
          <div className="divider-ornament"></div>
          <p className="section-subtitle">A peek into our story</p>
          <div className="gallery-grid">
            {GALLERY.map((src, i) => (
              <div key={i} className="gallery-item">
                <img src={src} alt={`Wedding moment ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* VIDEOS */}
      <section id="videos" className="videos-section fade-in">
        <div className="container">
          <h2 className="section-title">Wedding Invite</h2>
          <div className="divider-ornament"></div>
          <div className="videos-grid">
            {VIDEOS.map((v, i) => (
              <div key={i} className="video-card">
                {v.placeholder ? (
                  <div className="video-placeholder">
                    <div className="video-icon">📹</div>
                    <p>{v.title}</p>
                    <span className="video-coming-soon">Coming Soon</span>
                  </div>
                ) : (
                  <video
                    className="invitation-video"
                    controls
                    autoPlay
                    muted
                    loop
                    playsInline
                  >
                    <source src={v.videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* VENUE + MAP */}
      <section id="venue" className="venue-section fade-in">
        <div className="container">
          <h2 className="section-title">Our Wedding Venues</h2>
          <div className="divider-ornament"></div>
          
          {/* Main Venue */}
          <div className="venue-content">
            <div className="venue-map">
              <iframe
                title="Main Venue Map"
                loading="lazy"
                src="https://maps.google.com/maps?q=MH1+RESORT+GT+Karnal+Road+Alipur+Delhi&t=&z=15&ie=UTF8&iwloc=&output=embed"
              />
            </div>
            <div className="venue-details">
              <h3>{VENUES.main.name}</h3>
              <p className="venue-location">
                <MapPin size={18} />
                {VENUES.main.address}
              </p>
              <a className="btn-venue" href={VENUES.main.mapsUrl} target="_blank" rel="noopener noreferrer">
                <MapPin size={18} />
                Get Directions
              </a>
              <ul className="venue-info">
                <li>Mehendi, Ring Ceremony, Haldi & Wedding</li>
                <li>Parking & security available</li>
                <li>Please arrive 20–30 minutes early</li>
                <li>Contact: {RSVP.contactPerson}</li>
                <li>{RSVP.phone} / {RSVP.phone2}</li>
              </ul>
            </div>
          </div>

          {/* Reception Venue */}
          <div className="venue-content" style={{ marginTop: '60px' }}>
            <div className="venue-map">
              <iframe
                title="Reception Venue Map"
                loading="lazy"
                src="https://maps.google.com/maps?q=WEDLOCK+GREENS+Hotels+Resorts+Gobindpur+Dhanbad+Jharkhand&t=&z=15&ie=UTF8&iwloc=&output=embed"
              />
            </div>
            <div className="venue-details">
              <h3>{VENUES.reception.name}</h3>
              <p className="venue-location">
                <MapPin size={18} />
                {VENUES.reception.address}
              </p>
              <a className="btn-venue" href={VENUES.reception.mapsUrl} target="_blank" rel="noopener noreferrer">
                <MapPin size={18} />
                Get Directions
              </a>
              <ul className="venue-info">
                <li>Reception - Happily Ever After</li>
                <li>Date: 22nd February 2026</li>
                <li>Parking & security available</li>
                <li>Contact: {RSVP.contactPerson}</li>
                <li>{RSVP.phone} / {RSVP.phone2}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* RSVP */}
      <section id="rsvp" className="rsvp-section fade-in">
        <div className="container">
          <h2 className="section-title">Confirm Your Presence</h2>
          <div className="divider-ornament"></div>
          <p className="section-subtitle">
            Please let us know your plans so we can host you better
          </p>
          <div className="rsvp-content">
            <div className="rsvp-message">
              <h3>Confirm Your Attendance</h3>
              <p>
                We would be honored to have you celebrate with us on our special day. Please confirm your presence.
              </p>
              <div className="rsvp-actions">
                <a href={RSVP.formLink} target="_blank" rel="noopener noreferrer" className="btn-form">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="12" y1="18" x2="12" y2="12"></line>
                    <line x1="9" y1="15" x2="15" y2="15"></line>
                  </svg>
                  Confirm via Form
                </a>
              </div>
              <div className="rsvp-contact">
                <p style={{ fontWeight: '700', fontSize: '17px', marginBottom: '12px' }}>
                  {RSVP.contactPerson}
                </p>
                <p>
                  <Phone size={16} />
                  {RSVP.phone}
                </p>
                <p>
                  <Phone size={16} />
                  {RSVP.phone2}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DECORATIVE DIVIDER */}
      <div className="divider-section">
        <div className="divider-ornament"></div>
      </div>

      {/* FOOTER */}
      <footer className="footer-section">
        <div className="container">
          <div className="footer-content">
            <p className="footer-message">We can't wait to celebrate with you!</p>
            <p className="footer-hashtag">{HASHTAG}</p>
            <p className="footer-blessing">Kindly bless the couple with your presence</p>
          </div>
          <p className="footer-copyright">
            © {new Date().getFullYear()} {COUPLE.groom} & {COUPLE.bride}. All love reserved.
          </p>
        </div>
      </footer>
    </main>
  );
}

function TimeBox({ label, value }) {
  return (
    <div className="time-box">
      <div className="time-value">{String(value).padStart(2, '0')}</div>
      <div className="time-label">{label}</div>
    </div>
  );
}

function PersonCard({ name, subtitle, location, img }) {
  return (
    <div className="person-card">
      <div className="person-image">
        <img src={img} alt={name} loading="lazy" />
      </div>
      <div className="person-info">
        <h3>{name}</h3>
        <p className="person-subtitle">{subtitle}</p>
        <p className="person-location">{location}</p>
      </div>
    </div>
  );
}

function EventCard({ ev }) {
  return (
    <article className="event-card">
      <div className="event-image">
        {ev.videoUrl ? (
          <iframe
            className="event-video"
            src={`${ev.videoUrl}?autoplay=1&mute=1&loop=1`}
            title={ev.title}
            loading="lazy"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        ) : (
          <img src={ev.img} alt={ev.title} loading="lazy" />
        )}
      </div>
      <div className="event-content">
        <h3>{ev.title}</h3>
        {ev.subtitle && <p className="event-subtitle">{ev.subtitle}</p>}
        <p className="event-date">{ev.date}</p>
        <p className="event-time">{ev.time}</p>
        <p className="event-venue">{ev.venue}</p>
        {ev.venueAddress && <p className="event-venue-address">{ev.venueAddress}</p>}
        <div className="event-dress">
          <span>Dress: {ev.dress}</span>
        </div>
      </div>
    </article>
  );
}
